import ReactDOM from 'react-dom';
import React from 'react';
import Chuck from './Chuck';

ReactDOM.render(
  <Chuck message="Chuck Norris Random Wisdom!" />,
  document.getElementById("root")
);
